const HISTORY_PATHS_KEY = 'tmg_history_paths';
let memoryHistoryPaths: Record<number, string> = {};

export function normalizePath(pathname: string): string {
  const clean = pathname.replace(/\/+$/, '');
  return clean === '' ? '/' : clean;
}

function getStoredHistoryPaths(): Record<number, string> {
  if (typeof globalThis === 'undefined' || !globalThis.sessionStorage) {
    return memoryHistoryPaths;
  }
  try {
    const raw = globalThis.sessionStorage.getItem(HISTORY_PATHS_KEY);
    return raw ? JSON.parse(raw) : memoryHistoryPaths;
  } catch {
    return memoryHistoryPaths;
  }
}

function setStoredHistoryPaths(map: Record<number, string>) {
  memoryHistoryPaths = map;
  if (typeof globalThis !== 'undefined' && globalThis.sessionStorage) {
    try {
      globalThis.sessionStorage.setItem(HISTORY_PATHS_KEY, JSON.stringify(map));
    } catch {
      // Ignore storage errors
    }
  }
}

export function recordNavigation(index: number, pathname: string) {
  const normalized = normalizePath(pathname);
  const map = { ...getStoredHistoryPaths() };
  map[index] = normalized;

  for (const key of Object.keys(map)) {
    const num = Number(key);
    if (num > index) {
      delete map[num];
    }
  }
  setStoredHistoryPaths(map);
}

export function getPreviousPathname(currentIndex: number): string | undefined {
  if (currentIndex <= 0) {
    return undefined;
  }
  const map = getStoredHistoryPaths();
  return map[currentIndex - 1];
}

export function resetNavigationHistory() {
  memoryHistoryPaths = {};
  if (typeof globalThis !== 'undefined' && globalThis.sessionStorage) {
    try {
      globalThis.sessionStorage.removeItem(HISTORY_PATHS_KEY);
    } catch {
      // Ignore
    }
  }
}
